import React, {Component} from 'react';
import ReactTable from "react-table";
import 'react-table/react-table.css'
import ListingContainer from "../../containers/listing_container";
import DashboardContainer from "../../containers/dashboard_container";
import FilterAttributes from "../../containers/filter_container";
import { PROPERTY_VISIT_API_URL,COMPANY_API_URL } from "../../constants/api_routes";
import { Button, Form, Header, Icon, Modal, Popup, Grid, Checkbox,Input,Segment,Message,Dropdown,Card } from "semantic-ui-react";
import { bulkConfirmPVs,recordEmailAttempt,createPVAgent } from '../../data/property_visit_api';
import Loader from "../universal/loader";
import DayPickerInput from 'react-day-picker/DayPickerInput';
import {formatDate, parseDate} from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';
import moment from 'moment';
import {BASE_URL, CUSTOM_REPORT} from "../../constants/app_routes";
import {handleFileDownload} from "../../utils/download_file";
import DownloadingIntent from "../universal/toast";
import AddPropertyVisit from './add_property_visit';
import SendSMS from './send_sms';
import {getListingData} from '../../data/user_api';

class PropertyVisitSchedule extends Component {
    constructor(props) {
        super(props);
        this.state = {
            action: 'listing',
            showConfirm: false,
            dropdownValue: '',
            selectedInspectionDate: undefined,
            fromDate: undefined,
            toDate: undefined,
            dateFiltered: false,
            inspectionId: undefined,
            currentAssignedUser: undefined,
            isDownloading: false,
            selectiveQueries: false,
            checkedVisits:[],
            selectedPV:undefined,
            o365Checked:false,
            showNotSet:false,
            isAddingPV:false,
            companyData:[],
            companyLoading:true,
            selectedEmailOption:undefined,
            isMobile: window.innerWidth < 768,
        };
    }

    componentWillMount() {
         const user = JSON.parse(localStorage.getItem('user'));
        this.setState({userRole: user['role'],userId:user["user_id"]});
        this.setState({action: 'listing'});
        if (this.props.startDate && this.props.endDate) {
            this.setState({dateFiltered: true, fromDate: moment(this.props.startDate,"DD-MM-YYYY").format("YYYY-MM-DD"), toDate: moment(this.props.endDate,"DD-MM-YYYY").format("YYYY-MM-DD")});
        }
    }

    getCompanyData=  async(company) =>{
      if(this.state.companyData.length == 0){
          let response =  await getListingData(COMPANY_API_URL);
          let companyData = []
          response.map((item) =>{
            let  value = [item.email_report, item.email_invoice]
              .filter(v => v && v.trim() !== '')
              .join('; ');
            let isEmpty = value.length === 0;
            let comp = {key: item.id, text:item.name,value:value}

            if (!isEmpty) {
              companyData.push(comp)
            }
          })
          let emailOption = undefined
          let result = companyData.find(item => item.text === company);
          if (result) {
             emailOption = result.value
          }
          this.setState({selectedEmailOption: emailOption,companyLoading:false,companyData:[...companyData]})
           } else {
          let emailOption = undefined
          let result = this.state.companyData.find(item => item.text === company);
          if (result) {
             emailOption = result.value
          }
          this.setState({selectedEmailOption: emailOption})
           }
    }

    getPrevDay = () => {
      console.log(this.state.fromDate,this.state.dateFiltered)
                const currentDate = this.state.fromDate ? moment(this.state.fromDate, "YYYY-MM-DD") : moment();
                const prevDay = currentDate.subtract(1, 'days').format("YYYY-MM-DD");
            this.setState({
                fromDate: prevDay,
                toDate: prevDay,
                dateFiltered: true
            }, () => {
              this.props.getPropertyVisitsByDate(PROPERTY_VISIT_API_URL, this.state.fromDate, this.state.toDate)
            });
        };

            getNextDay = () => {
                const currentDate = this.state.fromDate ? moment(this.state.fromDate, "YYYY-MM-DD") : moment();
                const prevDay = currentDate.add(1, 'days').format("YYYY-MM-DD");
            this.setState({
                fromDate: prevDay,
                toDate: prevDay,
                dateFiltered: true
            }, () => {
              this.props.getPropertyVisitsByDate(PROPERTY_VISIT_API_URL, this.state.fromDate, this.state.toDate)
            });
        };

    handleAddPVSubmit = async (e) => {
      this.setState({isAddingPV:true,addError:undefined})
  e.preventDefault();
  const formData = {
    property_address: e.target.property_address.value,
    // date: e.target.date.value,
    // time: e.target.time.value,
    tenant_name: e.target.tenant_name.value,
    tenant_email: e.target.tenant_email.value,
    tenant_contact: e.target.tenant_contact.value,
    notes: e.target.notes.value,
  };
  
  let response = await createPVAgent(formData)

  if(response.success) {
        this.setState({isAddingPV:false,action:"listing"},()=>{this.props.getPropertyVisitsByAddress(PROPERTY_VISIT_API_URL,formData.property_address);this.setState({dateFiltered:true})})
        
  } else {
    this.setState({isAddingPV:false,addError:"There was an error while creating the PV, please try again or contact propertyvisits@hinchpm.com with your booking"})
  }





  // fetch('/api/save', { method: 'POST', body: JSON.stringify(formData) });
};
  renderEmailButton= () =>{
                 return <React.Fragment> {this.props.userRole === "admin" && this.state.checkedVisits.length > 0 && 
              <Popup on={"click"}trigger={<Button>Email</Button>} content={<div>
                <Checkbox toggle checked={this.state.o365Checked} label="Use Office 365" onChange={(e, data) => {this.setState({o365Checked:data.checked})}}></Checkbox>
                <hr/>
                <Button compact basic
              content='Default Email'
              onClick={() => this.handleBulkEmail()}
              /> <hr/>
              <Button compact basic
              content='KMP Email'
              onClick={() => this.handleBulkEmail("kmp")}
              /><hr/>
              <Button compact basic
              content='House Shaw Email'
              onClick={() => this.handleBulkEmail("shaw")}
              /><hr/>
              <Button compact basic
              content='House Shaw PDF Sending'
              onClick={() => this.handleBulkEmail("shawpdf")}/>
              </div>
            }></Popup> }</React.Fragment>
  }
    handleBulkEdit = () => {
        this.setState({action: 'bulkedit'});
    };

    handleDuplicate = (original) =>{
       this.setState({checkedVisits: [original], action:'duplicate' });

    }

    handleSingleEdit = (original) =>{
       this.setState({checkedVisits: [original], action:'bulkedit' });
    }

    handleBulkEmail = (emType="default") => {
      this.state.checkedVisits.forEach((visit) => {this.handleEmail(visit,emType)})
  };
  handleBulkConfirm = () => {
    let checkedVisits = [...this.state.checkedVisits]
    let visitIDs = []
    this.setState({bulkConfirmLoading:true})
    for (let i = 0; i < checkedVisits.length; i++ ) {
      visitIDs.push(checkedVisits[i].id)
    } 
    bulkConfirmPVs(PROPERTY_VISIT_API_URL, visitIDs).then(() => { this.refreshData(); this.setState({bulkConfirmLoading:false})})
  };
    refreshData = async () => {
        this.setState({ action: "listing", isFetching: true, isListFetching: true, isLoadingRefresh:true,checkedVisits:[] });
        if(this.state.fromDate && this.state.toDate){
            this.props.getPropertyVisitsByDate(PROPERTY_VISIT_API_URL, this.state.fromDate, this.state.toDate).then(() => { this.setState({ isLoadingRefresh: false })});
        }
        else {
            this.props.getList(PROPERTY_VISIT_API_URL).then(() => { this.setState({ isLoadingRefresh: false })})
        }
    }

  exportVisits = async () => {
    this.setState({isDownloading:true,showDownload:true});
    let URL = BASE_URL+"/export/property_visits";
    let fileName = "Property Visit List.xlsx";
    if(this.state.dateFiltered && this.state.fromDate && this.state.toDate){
        fileName = "Property Visit List -" + moment(this.state.fromDate).format("DD-MM-YYYY") + "-" + moment(this.state.toDate).format("DD-MM-YYYY") + " .xlsx";
        URL = BASE_URL + "/export/property_visits?start_date=" + this.state.fromDate + "&end_date=" + this.state.toDate;
    }
    await handleFileDownload(URL,fileName,'application/xlsx');
    this.setState({isDownloading:false});
  }


    handleText = (original) => {this.setState({action:"texting",selectedPV:original})}
    handleEmail = (original, emType = "default") => {
let subject = ""
let body = ""
let destEmail = original.tenant_email
console.log(["email type",emType])
      switch (emType) {

        case "shawpdf":
          subject = `${original.address} - Property Inspection`
          body = ``
          destEmail="houseshaw@mail.street.co.uk;cheshamlettings@houseshaw.co.uk"
        break;
        case "company":
          destEmail = `${this.state.selectedEmailOption || ""}`
          subject = `Property Visit report for ${original.address} `
          body =`Greetings, please see the Property Visit report attached for the above address`
        break;
        case "shaw":
          subject = `Property Visit scheduled for ${original.address}  on ${moment(original.visit_date).format("DD/MM/YYYY")} between 9am - 2pm. on behalf of House Shaw`

          body =`
Greetings

We require confirmation to this email

We are contacting you on behalf of House Shaw to arrange a property inspection at the above property on ${moment(original.visit_date).format("DD/MM/YYYY")} between 9am - 2pm.

The property visit will take no longer than 20 minutes and will include the below:

  -Noting of any maintenance issues at the property
  -Test all smoke and carbon alarms at the property
  -Inspect all rooms - these will need to be accessible on the day of the inspection

  We will need to take photos at the property of all rooms, if there are items that you wish to remove or cover please do before the time of the visit.

  [PLEASE NOTE] If you are unable to be home for the visit but wish for us to collect management keys please do confirm this by email also if you wish to discuss a new date or time frame please do contact me via email or on the number below.

Many Thanks
          `
          break;
        case 'kmp':
          subject = `Property Visit scheduled for ${original.address}  on ${moment(original.visit_date).format("DD/MM/YYYY")} Time-${original.visit_time} on behalf of ${original.company}`
          body = `CONFIRMATION REQUIRED

Greetings

A Property Visit has been scheduled for you on - ${moment(original.visit_date).format("DD/MM/YYYY")} witha time window of - ${original.visit_time}  on behalf of ${original.company}

As the tenant of ${original.address} we will require confirmation from yourself before we can attend.

The date of this visit is scheduled around a clerk being in the area and therefore we are unable to change the date. The letting agent does not hold keys for the property so we will need someone to be in attendance to carry this out.
 
If you require a smaller time window please do let us know
 
Please rely to this email as we will not attend without confirmation.

We look forward to your reply and being of service.

For more information, please visit www.hinchpm.com/pv

 
Thank you!`
          break;
        default:
      subject = `Confirmation Required : Property Visit scheduled for ${original.address}  on ${moment(original.visit_date).format("DD/MM/YYYY")} Time-${original.visit_time} on behalf of ${original.company}`
       body = `Dear Tenant,

Property Visit - Confirmation Required

A routine Property Visit has been scheduled on behalf of ${original.company} at the following property:

Property Address:
${original.address}

Date: ${moment(original.visit_date).format("DD/MM/YYYY")}
Appointment Window: ${original.visit_time}

The Property Visit is a routine contractual inspection designed to help ensure that the property remains in good condition and that any maintenance or safety matters are identified promptly, in the interests of all parties.

The visit will take approximately 15 minutes and will include the following:

- A general check of the condition of the property.
- Testing and recording all smoke and carbon monoxide alarms, where installed.
- Identifying any maintenance issues or repairs that may be required.
- Giving you the opportunity to raise any property-related concerns or maintenance issues.

Your Options

1. You are available during the appointment window:
Please reply to this email to confirm that you will be available for the visit.

2. The proposed date is not convenient:
Please reply with a few alternative dates and times that would be suitable for you, and we will do our best to arrange an alternative appointment.

3. You are happy for us to access the property in your absence
If you are unable to be present but are happy for us to use our management keys to access the property, please reply to confirm that you give us permission to do so.

For further information about Property Visits, please visit:

www.hinchpm.com/pv

Thank you for your cooperation. We look forward to hearing from you.
`;
      }

if(this.state.o365Checked) {
  window.open(`https://outlook.office.com/mail/deeplink/compose?to=${destEmail}&subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`)  
} else {
  window.open(`mailto:${destEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`)}
      recordEmailAttempt(PROPERTY_VISIT_API_URL,original.id)
    }
    handlePVReport = (visit) => {
          if ((this.props.userRole === 'clerk' && (visit.status ===  "submitted") || visit.status === "completed")  || (this.props.userRole === 'admin' && visit.status === "completed")) {
            if(!this.state.isDownloading) {
              return(this.handleDownload(visit["id"], visit["filename"]))
            } 
          }
          else {
              return ( Object.assign(document.createElement('a'), { target: '_blank', href: "/property_visit/report/" + visit.id}).click())
          }
  };
    handleDownload = async (id, visit) => {
        this.setState({isDownloading: true, showDownload: true});
        let URL = BASE_URL + "/pv/download/" + id;
        let fileName = visit;
        await handleFileDownload(URL, fileName,);
        this.setState({isDownloading: false});
    };

    componentWillUnmount() {
        this.props.setFilter(undefined, undefined, undefined , undefined);
    }

    handleFilterSelection = () => {
        this.setState({dateFiltered: true, isLoadingRefresh:true,checkedVisits:[]});
        if(this.state.fromDate && this.state.toDate){
            this.props.getPropertyVisitsByDate(PROPERTY_VISIT_API_URL, this.state.fromDate, this.state.toDate).then(() => {this.setState({isLoadingRefresh:false})});
        }
    };


    render() {
        const statusOptions = 
          {'pending':'Pending',
          'scheduled':'Scheduled',
          'contacted' : 'Contacted',
          'confirmed':'Confirmed',
          'processing':'Processing',
          'submitted':'Submitted',
          'completed':'Completed',
          "due" : "Due",
          'cancelled': 'Cancelled',
          'aborted': 'Aborted'
        }
          
        const columns = [
          {
            Header: "Date",
            id: "visit_date",
            accessor: "visit_date",
            className: "date-width",
            headerClassName: "date-width",
            maxWidth: 125,
            filterable: true,
            filterMethod: (filter, row) => {
              const id = filter.pivotId || filter.id;
              return row[id] !== null
                ? row[id] !== undefined
                  ? moment(row[id], "YYYY-MM-DD HH:mm Z")
                      .format("DD:MM:YYYY")
                      .toUpperCase()
                      .indexOf(filter.value.toUpperCase()) >= 0
                  : true
                : "NOT SET".indexOf(filter.value.toUpperCase()) >= 0;
            },
            Cell: ({ original, value }) => (
            <React.Fragment>
              <Popup
              content={<div><strong>Date Created: </strong>{moment(original["created_at"]).format("DD-MM-YYYY")}</div>}
                trigger={original["visit_date"] !=undefined 
                  ? <span>{moment(original["visit_date"], "YYYY-MM-DD HH:mm Z").format(
                    "DD-MM-YYYY")}</span>
                  : <span className="status-red">NOT SET</span>} />
              </React.Fragment>
            ),
          },
          {
            Header: "Time",
            id: "time",
            accessor: "visit_time",
            className: "date-width",
            headerClassName: "date-width",
            maxWidth: 125,
            filterMethod: (filter, row) => {
              const id = filter.pivotId || filter.id;
              return row[id] !== undefined
                ? String(row[id])
                    .replace(/[^\w]/g, "")
                    .toUpperCase()
                    .indexOf(
                      filter.value.replace(/[^\w]/g, "").toUpperCase()
                    ) >= 0
                : true;
            },
            filterable: true,
            Cell: ({ original, value }) => <span>{value}</span>,
          },
          {
            Header: "Company",
            id: "company",
            accessor: "company",
            className: "left-aligned",
            maxWidth: "200",
            filterMethod: (filter, row) => {
              const id = filter.pivotId || filter.id;
              return row[id] !== undefined
                ? String(row[id])
                    .replace(/[^\w]/g, "")
                    .toUpperCase()
                    .indexOf(
                      filter.value.replace(/[^\w]/g, "").toUpperCase()
                    ) >= 0
                : true;
            },
            filterable: true,
            Cell: ({ original, value }) => <span>{value}</span>,
          },
          {
            Header: "Branch",
            id: "branch",
            accessor: "branch",
            maxWidth: "100",
            filterMethod: (filter, row) => {
              const id = filter.pivotId || filter.id;
              return row[id] !== undefined
                ? String(row[id])
                    .replace(/[^\w]/g, "")
                    .toUpperCase()
                    .indexOf(
                      filter.value.replace(/[^\w]/g, "").toUpperCase()
                    ) >= 0
                : true;
            },
            filterable: true,
            Cell: ({ original, value }) => <span>{value?value:"N/A"}</span>,
          },
          {
            Header: "Address",
            id: "address",
            className: "left-aligned",
            accessor: (d) => d["address"],
            filterMethod: (filter, row) => {
              const id = filter.pivotId || filter.id;
              return row[id] !== undefined
                ? String(row[id])
                    .replace(/[^\w]/g, "")
                    .toUpperCase()
                    .indexOf(
                      filter.value.replace(/[^\w]/g, "").toUpperCase()
                    ) >= 0
                : true;
            },
            filterable: true,
            Cell: ({ original, value }) => (
              <div>
                <Popup
                  trigger={<span>{value}</span>}
                  content={
                    <div style={{ paddingTop: "5px" }}>
                      <span>{value}</span>
                    </div>
                  }
                  position="top left"
                  on="hover"
                  wide
                  header="Visit Address"
                  hideOnScroll
                />
              </div>
            ),
          },
          {
            Header: "Assigned To",
            id: "clerk",
            accessor: "clerk",
            maxWidth: "200",
            filterMethod: (filter, row) => {
              const id = filter.pivotId || filter.id;
              return row[id] !== undefined
                ? String(row[id])
                    .replace(/[^\w]/g, "")
                    .toUpperCase()
                    .indexOf(
                      filter.value.replace(/[^\w]/g, "").toUpperCase()
                    ) >= 0
                : true;
            },
            filterable: true,
            Cell: ({ original, value }) => <span className={value?null:"status-red"}>{value?value:"Un Assigned"}</span>,
          },{
            Header: "Access/Notes",
            id: "notes",
            accessor: "notes",
            className: "format-capitalize",
            maxWidth: 150,
            Cell: ({ original, value }) => (
              <div>
                <Button.Group compact size="mini">   
                  
                 { value && value.length > 1 && <Popup on={['click']}
                  trigger={<Button icon basic  color="red">
                  {value && value.includes("(A)") && <Icon color="blue" name="alarm" />}
                  {value && value.includes("?") && <Icon color="orange" name="question" />}NOTES
                </Button>}
                  content={
                    <div style={{ paddingTop: "5px" }}>
                      <span>{value}</span>
                    </div>
                  } position="top left" wide  header="Visit Notes" hideOnScroll />}


                {original.access_notes && original.access_notes.length > 1 && <Popup on={['click']}
                  trigger={<Button basic color="green" >
                    ACCESS
                </Button>}
                  content={
                    <div style={{ paddingTop: "5px" }}>
                      <span>{original.access_notes}</span>
                    </div>
                  }
                  position="top left"
                  wide
                  header="Access / Key Notes"
                  hideOnScroll
                />}

                {this.props.userRole == "admin" && original.conclusion_notes && original.conclusion_notes.length > 1 && <Popup on={['click']}
                  trigger={<Button basic icon color="blue">
                  C.NOTES {original.conclusion_notes && original.conclusion_notes.includes("?") && <Icon color="orange" name="question" />}
                  {original.conclusion_notes && original.conclusion_notes.includes("(A)") && <Icon color="blue" name="alarm" />}
                  {original.conclusion_notes && original.conclusion_notes.includes("(CS)") && <Icon color="blue" name="flag" />}
                </Button>}
                  content={
                    <div style={{ paddingTop: "5px" }}>
                      <span>{original.conclusion_notes}</span>
                    </div>
                  }
                  position="top left"
                  wide
                  header="Visit Conclusion Notes"
                  hideOnScroll
                />}
                </Button.Group>
              </div>
            ),
          },
          {
            Header: "Tenant Info",
            id: "tenant_info",
            className: "format-capitalize",
            width:200,
            maxWidth: 200,
            Cell: ({ original, value }) => (
              <div>
              <Popup
                trigger={
                  <Button compact size="mini" color="blue">
                    INFO
                  </Button>
                  
                }
                content={
                  <div style={{ paddingTop: "5px" }}>
                    <hr />
                    <strong>Tenant Name: </strong>
                    {original.tenant_name}
                    <hr />
                    <strong>Tenant Email: </strong>
                    {original.tenant_email}
                    <hr />
                    <strong>Tenant Contact: </strong>
                    {original.tenant_contact}
                  </div>
                }
                position="top left"
                on={['click']}
                wide="very"
                header="Tenant Info"
                hideOnScroll
              />
              {/* {original.tenant_confirmed && <Button basic compact icon color="green" size="mini" as="a" target="_blank"  >Confirmed</Button> }
              
              {!original.tenant_confirmed && <Button basic compact icon color="red" size="mini" as="a" target="_blank"  >Unconfirmed</Button>} */}
              {(original.email_attempts.length > 0 || original.text_attempts.length > 0)?
              <Popup on="click" wide="very" trigger={
                <Button basic compact icon color="green" size="mini" as="a" target="_blank"  >Contacted</Button>
              }
              content={<div>
                {original.email_attempts.length > 0 && <div>Email Attempts <ul>{original.email_attempts.map(attempt =>{return <li key={attempt}>{moment(attempt).format('DD/MM/YYYY [@] HH:mm')}</li>})}</ul>
                </div>}
                {original.text_attempts.length > 0 &&<div>Text Attempts <ul>{original.text_attempts.map(attempt =>{return <li key={attempt}>{moment(attempt).format('DD/MM/YYYY [@] HH:mm')}</li>})}</ul>
                </div>}
                </div>}
              >
              </Popup>
              :<Button basic compact icon color="red" size="mini" as="a" target="_blank"  >Uncontacted</Button>}
              </div>
            ),
          },
          {
            Header: "Status",
            id: "status",
            accessor: "status",
            className: "format-capitalize",
            maxWidth: 150,
            Cell: ({ original, value }) => (
              <div>
                <Button size="mini" compact>
                  {statusOptions[value]}
                </Button>
              </div>
            ),
            filterMethod: (filter, row) => {
              if (filter.value !== "") {
                if (filter.value == "not_downloaded") {return (row[filter.id] === "completed") && (row._original.pdf_downloaded == false);} 
                  else if (filter.value === "due") {
                       if ((moment(row.visit_date,"YYYY-MM-DD").businessDiff( moment()) >2)&& moment(row.visit_date,"YYYY-MM-DD") < moment()) {
                                            return (row[filter.id] === 'scheduled' || row[filter.id] === 'confirmed' || row[filter.id] === "processing")
                                        }
                  }
                   else return row[filter.id] === filter.value;
              } else return true;
            },
            Filter: ({ filter, onChange }) => (
              <select
                onChange={(event) => onChange(event.target.value)}
                style={{ width: "100%" }}
                value={filter ? filter.value : ""}
              >
                <option value="">Show All</option>
                <option value="pending">Pending</option>
                <option value="scheduled">Scheduled</option>
                <option value="confirmed">Confirmed</option>
                <option value="processing">Processing</option>
                <option value="submitted">Submitted</option>
                <option value="completed">Completed</option>
                <option value="due">Due</option>
                <option value="cancelled">Cancelled</option>
                <option value="aborted">Aborted</option>
                <option value="not_downloaded">Not Downloaded</option>
              </select>
            ),

            filterable: true,
          },
          {
            Header: "Action",
            id: "edit",
            maxWidth: 200,
            headerClassName: "table-actions",
            className: "table-actions",
            accessor: "id",
            sortable: false,
            Cell: ({ original, value }) => (
              <div>
              {this.props.userRole === 'admin' && <Popup wide="very" on="click" trigger={<Button onClick={()=>{this.getCompanyData(original["company"])}} size="mini" basic compact icon color="red">Tools<Icon name="settings"></Icon></Button>}><Button.Group size="mini"><Button  basic  compact icon  color="red"  size="mini"  as="a"  target="_blank" onClick={() => {this.handleText(original)}}  >SMS <Icon name="text telephone" /> </Button>
              <Button basic compact  icon  color="blue" size="mini" as="a"  target="_blank" onClick={() => {this.handleEmail(original)}}>Email TT <Icon name="mail" /></Button>
                </Button.Group><hr/> 
                <Button basic compact  icon color="red" size="mini" as="a" target="_blank"  onClick={() =>  {this.handleDuplicate(original)}} >Duplicate <Icon name="copy" />
                </Button> <hr/>
                <Button basic compact icon color="orange" size="mini" as="a" target="_blank" 
                onClick={() => {this.handleEmail(original,"company")}}
                >Email Company <Icon name="mail" /> </Button>
                  <div>
                    {this.state.companyLoading && <Button loading disabled/> }
                    {!this.state.companyLoading &&             <Dropdown search value={this.state.selectedEmailOption} placeholder='Email To' fluid selection options={this.state.companyData} onChange={(e,{value}) => {this.setState({selectedEmailOption:value})}}/>}
                  </div>
                
                </Popup>}
                {this.props.userRole === 'admin' &&<Button
                  basic
                  compact
                  icon
                  color="blue"
                  size="mini"
                  as="a"
                  target="_blank"
                  onClick={() => {this.handleSingleEdit(original)}}
                >Edit <Icon name="edit" />
                </Button>}
                <Button
                  basic
                  compact
                  icon
                  color="orange"
                  size="mini"
                  disabled={
                    !(original.clerk &&
                      original.clerk_id && original.visit_date && !(original.status == "pending" || original.status == "aborted" || original.status == "cancelled" ||(original.status != "completed" && this.props.userRole === "agent" )  ))
                  }
                  as="a"
                  target="_blank"
                  onClick={() => {this.handlePVReport(original)}}
                >Report <Icon name="arrow right" />
                </Button>
              </div>
            ),
          },
          this.props.userRole !='agent' && {
            Header: "Selection",
            id: "edit",
            headerClassName: "table-actions",
            className: "table-actions",
            accessor: "id",
            maxWidth: "100",
            sortable: false,
            Cell: ({ original, value }) => (
              <div>
                <Checkbox disabled = {original.status != "scheduled" && this.props.userRole === "clerk"}
                  onChange={(e, data) => {
                    if (data.checked == true) {
                      this.state.checkedVisits.find(
                        (e) => e.id === original.id
                      );
                      this.setState({
                        checkedVisits: [...this.state.checkedVisits, original],
                      });
                    } else {
                      this.setState({
                        checkedVisits: this.state.checkedVisits.filter(
                          (e) => e.id != original.id
                        ),
                      });
                    }
                  }}
                  checked={
                    this.state.checkedVisits.find(
                      (e) => e.id === original.id
                    ) !== undefined
                  }
                />
              </div>
            ),
          },
        ];
        return (<div className="listing-container">
            <Grid stackable>
                    <Grid.Row>
                        <Grid.Column width={5}>
                          <div >
                            <Header style={{display:"inline",margin:"5px"}}> PVs</Header>
                            {this.state.userRole == "agent" &&<Button icon="plus" onClick={()=>{this.setState({action:"addPV"})}} />}
                            <Popup
                            trigger={<Button icon onClick={()=>{this.setState({isMobile:!this.state.isMobile})}}><Icon name="eye"></Icon></Button> }
                            content={<span>Toggle Mobile View</span>} />
                            <Popup trigger={<Button  icon="download"></Button> }
                            content={<div className="pad-top">{this.state.dateFiltered ? <p>Visits from {moment(this.state.fromDate, "DD-MM-YYYY").format("DD-MM-YYYY")} to {moment(this.state.toDate, "DD-MM-YYYY").format("DD-MM-YYYY")}</p> : <p>Todays {moment().format("DD-MM-YYYY")} Visits</p>}
                                <Button content="Export Visits (By Inspection Date)" icon="download" labelPosition="left" onClick={() =>this.exportVisits()} /></div>}
                                    header="Export" on='click' position="bottom center" flowing hideOnScroll wide />
                             <Popup trigger={<div style={{display:"inline"}}><Button onClick={()=>{this.setState({showNotSet: !this.state.showNotSet})}}  icon><Icon name={this.state.showNotSet ? "unhide" : "hide"} /> {this.state.showNotSet? "Showing No Date / Pending" :"Hiding No Date / Pending"}</Button></div> }
                            content={<div> Currently {this.state.showNotSet? "showing":"hiding"} visits that are pending or without a set date.  </div>}
                                    position="bottom center" flowing hideOnScroll wide />
                               {this.props.userRole =="admin" &&
                                                              <Popup trigger={<Button as="a" href={"/property_visit/create"} primary icon > <Icon name='plus'/>
                                                              </Button>}
                                                              content={<span>Add New Property Visit</span>}
                                                              />}       
                                    </div>
                        </Grid.Column>
                        <Grid.Column width={3}>                                
                        <Input onKeyPress={
                            (e)=>{
                                if(e.key==="Enter") {
                                    this.props.getPropertyVisitsByAddress(PROPERTY_VISIT_API_URL,this.state.searchAddress.replace(",",""));this.setState({dateFiltered:true,showNotSet:true})
                                }
                            }}onChange={e=>{this.setState({searchAddress: e.target.value})}} placeholder="Search by address"label={<Button disabled={(this.state.searchAddress || "").length < 4} onClick={()=>{this.props.getPropertyVisitsByAddress(PROPERTY_VISIT_API_URL,this.state.searchAddress);this.setState({dateFiltered:true, showNotSet:true})}}content='Search' />} labelPosition='right'/></Grid.Column>
                        <Grid.Column width={3}>
                            {this.state.dateFiltered && moment(this.state.toDate).isValid() ?
                            <div className="center-aligned" style={{lineHeight: '2.7em'}}><span>Showing Visits from :</span><span
                                className="format-bold">{moment(this.state.fromDate).format("DD-MM-YYYY").toString()}</span><span> to </span><span
                                className="format-bold">{moment(this.state.toDate).format("DD-MM-YYYY").toString()}</span>
                            </div>:<div className="center-aligned" style={{lineHeight: '2.7em'}}> <span>Showing Recent Visits </span></div> }
              </Grid.Column>
              <Grid.Column width={3} className="right-aligned"><div></div>{this.props.userRole === "admin" && !this.state.isLoadingRefresh && 
              <Button
                content='Edit'
                primary
                onClick={() => this.handleBulkEdit()}
                disabled={this.state.checkedVisits.length < 1}
                label={{ as: 'a', basic: true, content: `${this.state.checkedVisits.length} Selected` }}
                labelPosition='left'
              />}
             { this.renderEmailButton()}
                {this.props.userRole === "clerk" && !this.state.isLoadingRefresh && <Popup wide="very" on="click" trigger={<Button
                  content='Confirm'
                  primary
                  disabled={this.state.checkedVisits.length < 1}
                  label={{ as: 'a', basic: true, content: `${this.state.checkedVisits.length} Selected` }}
                  labelPosition='left'
                />}
                  content={<div><Header>Change status to confirmed?</Header><Button loading={this.state.bulkConfirmLoading} disabled={this.state.bulkConfirmLoading} onClick={()=>{this.handleBulkConfirm()}} fluid positive style={{ width: "60%", margin:"auto"}}> Yes</Button></div> } />}
              </Grid.Column>
                        <Grid.Column width={2} className="right-aligned">
                          <Button.Group>
                            <Popup
                                trigger={<Button disabled={this.props.isFetching || (this.state.dateFiltered && this.props.isPVDataByDateFetching)} onClick={()=>{this.getPrevDay()}}icon='left arrow' />}
                                  content='Previous Day'  position='top center'size='tiny'
                                />
                                <Popup
                                trigger={<Button  content='Date'/>}
                                content={<div>
                                    <div><Header
                                        content="Filter Visits By Date"/><Form><span><b>From: </b><DayPickerInput
                                        placeholder="From"
                                        dayPickerProps={{
                                            todayButton: 'Today',
                                            firstDayOfWeek : 1,
                                        }}
                                        format="DD-MM-YYYY"
                                        value={this.state.fromDate?moment(this.state.fromDate).format("DD-MM-YYYY"):moment().format("DD-MM-YYYY")}
                                        formatDate={formatDate}
                                        parseDate={parseDate}
                                        onDayChange={day => {day ? this.setState({fromDate: day,toDate:day}): this.setState({fromDate:undefined})}}/></span>
                                        <span><b>To: </b><DayPickerInput
                                            placeholder="To"
                                            format="DD-MM-YYYY"
                                            formatDate={formatDate}
                                            value={moment(this.state.toDate).format("DD-MM-YYYY")}
                                            parseDate={parseDate}
                                            dayPickerProps={{
                                                disabledDays: {before: this.state.fromDate},
                                                todayButton: 'Today',
                                                firstDayOfWeek : 1,
                                            }}
                                            onDayChange={day => {day ?this.setState({toDate: day}): this.setState({endDate:undefined}) }}/></span></Form></div>
                                    <br/>
                                    <div style={{width: '100%'}} className="right-aligned"><Button
                                        content="Get Visits" primary
                                        onClick={() => this.handleFilterSelection()}/></div>
                                </div>}
                                on='click'
                                position="bottom left"
                                flowing
                                hideOnScroll
                                wide
                            />  <Popup
                                  trigger={<Button disabled={this.props.isFetching || (this.state.dateFiltered && this.props.isPVDataByDateFetching)} onClick={()=>{this.getNextDay()}}icon='right arrow' />}
                                  content='Next Day'  position='top center'size='tiny'
                                />
                            </Button.Group>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            <div className="pad-top pad-bottom center-aligned">
                {this.state.isLoadingRefresh && <Loader customText="Loading PVs for Date" contain={true} />}
                {(!this.state.dateFiltered && this.props.isFetching) && <Loader customText="Loading PV List" contain={true}/>}
                    {(this.state.dateFiltered && this.props.isPVDataByDateFetching)&& !this.state.isLoadingRefresh ? <Loader customText="Loading PVs for Date" marginBottom="1000px" contain={true} /> : this.props.isListFetching ? <Loader customText={"Loading inspection data, sit tight!"} marginBottom="1000px" contain={true}/> : null}
                    {(this.props.propertyVisitData || (this.props.propertyVisitDataByDate)) && <React.Fragment>
                    {!this.state.isMobile && <ReactTable
                        data={this.props.userRole == "agent" ? (!this.state.dateFiltered ? this.props.propertyVisitData || [] : this.props.propertyVisitDataByDate || []).filter(item => this.state.showNotSet || (item.visit_date && item.status !== "pending")):(!this.state.dateFiltered ? this.props.propertyVisitData.filter(item => this.state.showNotSet || (item.visit_date && item.status !== "pending")) : (this.props.propertyVisitDataByDate|| []).filter(item => this.state.showNotSet || (item.visit_date && item.status !== "pending")))}
                        columns={columns}
                        defaultFilterMethod={(filter, row, column) => {
                            const id = filter.pivotId || filter.id;
                            return row[id] !== undefined ? String(row[id]).toUpperCase().startsWith(filter.value.toUpperCase()) : true
                        }}
                        defaultPageSize={500}
                        defaultSorted={[{
                            id: 'status',
                            desc: false,
                        },{
                            id: 'user',
                            desc: false
                        }, ]}
                        defaultFiltered={[{
                            id: 'status',
                            value: this.props.filterStatus ? this.props.filterStatus : ""
                        }]}
                        minRows={12}
                        style={{
                            height: '620px'
                        }}
                        noDataText="No Visits Found in Selected range"
                        pageSizeOptions={[5, 10, 20, 25, 50, 100,200,500]}
                    />}

                    {this.state.isMobile && <Card.Group centered>                   
                    {(!this.state.dateFiltered ? this.props.propertyVisitData.filter(item => this.state.showNotSet || (item.visit_date && item.status !== "pending")) : (this.props.propertyVisitDataByDate|| []).filter(item => this.state.showNotSet || (item.visit_date && item.status !== "pending"))).map( insp =>{ 
                  return <Card>
                        <Card.Content>
                          <Card.Header>{insp.address}</Card.Header>
                          <Card.Meta> <div class="schedule-card"style={{textAlign:"left"}}><Icon name="calendar"></Icon>DATE:{ <Button compact circular basic >{moment(insp['visit_date'], "YYYY-MM-DD HH:mm Z").format("DD-MM-YYYY (ddd)")}</Button>
                          } <br/>
                                    <Icon name="clock"></Icon> TIME:<Button compact circular basic >{insp["visit_time"]} </Button> <br/>
                                    <Icon name="settings"></Icon>JOB TYPE:<Button compact circular basic > PV</Button><br/>
                                    <Icon name="at"></Icon>COMPANY:<Button compact circular basic > {insp.company} </Button> <br/>
                                    <Icon name="key"></Icon> ACCESS NOTES:  <Popup trigger={<Button compact circular basic > {insp.access_notes && insp.access_notes.trim() ? "Tap to see ":"None"}</Button>}
                                      content={insp.access_notes}/><br/>
                                       <Icon name="clock"></Icon> TENANT INFO:<Popup
                trigger={  <Button compact basic circular > Tap To See  </Button>  }
                content={   <div style={{ paddingTop: "5px" }}>   <hr />   <strong>Tenant Name: </strong>
                    {insp.tenant_name}
                    <hr />
                    <strong>Tenant Email: </strong>
                    {insp.tenant_email}
                    <hr />
                    <strong>Tenant Contact: </strong>
                    {insp.tenant_contact}
                  </div>  }   position="top left"  on={['click']}  wide="very" header="Tenant Info" hideOnScroll  /><br/>
                                      <Icon name="list"></Icon>NOTES:                    <Popup trigger={<Button compact circular basic > {insp.notes && insp.notes.trim() ? "Tap to see ":"None"}</Button>}
                                      content={insp.notes}/><br/>
                                      <div>   <Icon name="info"/>STATUS:<Button compact circular basic > {insp.status && insp.status.toUpperCase()} </Button> <br/>
                                  </div>
                          </div></Card.Meta>
                        </Card.Content>
                        <Card.Content extra>
            {this.props.userRole !== 'agent' &&
                          <div className='ui two buttons'>
                <div>
                  {this.state.checkedVisits.find(
                      (e) => e.id === insp.id
                    ) ?<Button  basic icon="check" color='blue' content="Checked" onClick={ ()=>this.setState({ checkedVisits: this.state.checkedVisits.filter((e) => e.id != insp.id)})}/> : <Button basic icon="close" color='red' content="Unchecked" disabled = {insp.status != "scheduled" && this.props.userRole === "clerk"}
                  onClick={() => {
                    this.setState({
                        checkedVisits: [...this.state.checkedVisits, insp],
                      });
                  }}
                /> }
              </div>
             <Button icon color='orange' basic disabled={  !(insp.clerk &&  insp.clerk_id && insp.visit_date && !(insp.status == "pending" || insp.status == "aborted" || insp.status == "cancelled" ||(insp.status != "completed" && this.props.userRole === "agent" )  ))  }  as="a" target="_blank"  onClick={() => {this.handlePVReport(insp)}}  > Report <Icon name='arrow right'/></Button>            
          </div>}
        </Card.Content>
      </Card>})}</Card.Group>}</React.Fragment>}</div>
          <Modal size={"fullscreen"} open={this.state.action === "bulkedit" || this.state.action === "duplicate"} closeOnDimmerClick={false} onClose={(e) => {(this.refreshData())
                    }}>
                        <Modal.Content>
                            <div className="modal-close-button">
                                <Button basic icon negative onClick={(e) => {
                                    this.refreshData()
                                }}><Icon name="close"/></Button>
                            </div>
                        <Modal.Description>
                {this.state.action === "bulkedit" && <AddPropertyVisit refreshData={this.refreshData } editMode={true} checkedVisits={this.state.checkedVisits} />
                }
                {this.state.action === "duplicate" && <AddPropertyVisit refreshData={this.refreshData } duplicate checkedVisits={this.state.checkedVisits} />
                }
              </Modal.Description>
            </Modal.Content>
          </Modal>
          <Modal open={this.state.action === "texting"} closeOnDimmerClick={false} onClose={(e) => {(this.setState({action:"listing",selectedPV:undefined}))}}>
                        <Modal.Content>
                            <div className="modal-close-button">
                                <Button basic icon negative onClick={(e) => {
                                   this.setState({action:"listing",selectedPV:undefined})
                                }}><Icon name="close"/></Button>
                            </div>
              <Modal.Description>
                {this.state.action == "texting" && <SendSMS selectedPV={this.state.selectedPV}></SendSMS>}
              </Modal.Description>
            </Modal.Content>
          </Modal>
            <Modal open={this.state.action === "addPV"} closeOnDimmerClick={false} onClose={(e) => {(this.setState({action:"listing"}))}}>
                        <Modal.Content>
                            <div className="modal-close-button">
                                <Button basic icon negative onClick={(e) => {
                                   this.setState({action:"listing"})
                                }}><Icon name="close"/></Button>
                            </div>
              <Modal.Description>
                <Header>Add PV</Header>
                <Message>Please ensure the PV you are trying to create does not already exist in our system by searching for it by address using the search bar at the center top of the schedule screen.</Message>
                  <Segment>
                    {this.state.addError && <Message>{this.state.addError}</Message>}
                        <Form onSubmit={this.handleAddPVSubmit}>
                          <Form.Input label="Property Address" name="property_address" placeholder="Enter property address" required />
                          {/* <Form.Field>
                                      <label>Date</label>
                                      <DayPickerInput
                                        ref={this.dateInputRef}
                                        placeholder="DD-MM-YYYY"
                                        format="DD-MM-YYYY"
                                        formatDate={formatDate}
                                        parseDate={parseDate}
                                        dayPickerProps={{
                                          todayButton: 'Clear',
                                          firstDayOfWeek: 1
                                        }}
                                      />
                          </Form.Field>
                          <Form.Input label="Time" name="time" placeholder="Enter time" /> */}
                          <Form.Input label="Tenant Name" name="tenant_name" placeholder="Enter tenant name" />
                          <Form.Input label="Tenant Email" name="tenant_email" placeholder="Enter tenant email" />
                          <Form.Input label="Tenant Contact" name="tenant_contact" placeholder="Enter tenant contact number" />
                          <Form.TextArea label="Notes" name="notes" placeholder="Additional notes" />
                          <Button loading={this.state.isAddingPV}disabled={this.state.isAddingPV}type="submit" primary>Submit</Button>
                        </Form>
                      </Segment>
              </Modal.Description>
            </Modal.Content>
          </Modal>
                {this.state.showDownload && <DownloadingIntent isDownloading={this.state.isDownloading}/>}
            </div>
        );
    }

}

export default FilterAttributes(DashboardContainer(ListingContainer(PropertyVisitSchedule)));


// WEBPACK FOOTER //
// ./src/views/property_visits/property_visit_schedule.js